import { State } from '@/views/heat-map-configuration/heat-map-configuration.types';

const state: State = {
  heatMapValues: [],
};

export default state;
